import { renderContentWithTrackedLinks } from "utils/format";
import React from "react";

const CompanyInformationTab = ({jobInfomation}: any) => {
  const jobInfo = {
    ...jobInfomation,
    change_scope: { value: jobInfomation.is_change_scope ? "あり" : "なし", note: jobInfomation.change_scope },
  }
  return (
    <>
    <div className="mb-8">
      <h5 className="text-sm font-bold lg:font-normal lg:text-2xl lg:leading-9 alu-text-base-2 mb-2 lg:mb-3">
        職務内容
      </h5>
      <p className="text-sm font-normal alu-text-base-2 whitespace-pre-wrap break-all">
        {renderContentWithTrackedLinks(jobInfo.description)}
      </p>
    </div>
    <div>
      <h5 className="text-sm font-bold lg:font-normal lg:text-2xl lg:leading-9 alu-text-base-2 mb-2 lg:mb-3">
        職務内容変更の範囲
      </h5>
      <p className="text-sm font-normal alu-text-base-2 whitespace-pre-wrap break-all">
        {jobInfo.is_change_scope ? renderContentWithTrackedLinks(jobInfo.change_scope.note) : 'なし'}
      </p>
    </div>
    </>
  );
};

export default CompanyInformationTab;
